import { useQuery } from "@tanstack/react-query"
import { assessmentsHooks } from "pages/School/Assessments"
import { getTranscriptionUsersFetch } from "store/middlewares/user.crud"
import qc from "keys/queryClient"

const useFilterItems = () => {
    const headerItems = assessmentsHooks.useHeaderItems()

    const transcriptionUsers = useQuery({
        queryKey: [qc.transcriptionUsers],
        queryFn: async ({ signal }) => {
            const { data } = await getTranscriptionUsersFetch()
            return data
        }
    })

    const filterItems = [
        headerItems.year,
        headerItems.semester,
        headerItems.grade_of_execution,
        headerItems.category,
        headerItems.assessment_def,
        {
            name: "marking_words_update_by",
            component: "autoComplete",
            placeholder: "בחר מתעתק",
            options: transcriptionUsers.data
        }
    ]

    return filterItems
}

export default useFilterItems